module.exports = __webpack_public_path__ + "static/media/centrica-logo.be1da0e7.png";